import axios from 'axios'

const instance = axios.create({
    baseURL: 'https://sarahwebsite-e1a68.firebaseio.com/'
})

export default instance


